module.exports = "/img/7.3c452a.webp";